import {BrandType} from '../../../../../provider/brands/brand-type';
import {CompetitorType} from '../../../../../service/reivew-analysis/competitors/competitors-type';

export enum LegendBoxColorKeyEnum {
    stripes = 'stripes',
    average_line = 'average_line',
    chart_1 = 'chart_1',
    chart_2 = 'chart_2',
    chart_3 = 'chart_3',
    chart_4 = 'chart_4',
    chart_5 = 'chart_5',
    chart_6 = 'chart_6',
    chart_7 = 'chart_7',
    chart_8 = 'chart_8',
    chart_9 = 'chart_9',
    chart_10 = 'chart_10',
    chart_11 = 'chart_11',
}

export type DashboardChartColorType = {
    lineColor: string;
    areaColor: string;
    legendBoxColorKey: LegendBoxColorKeyEnum;
};

export type ReviewAnalysisBrandHookResultType = {
    nameMap: Record<number, string>;
    customerBrands: Array<BrandType>;
    selectedCustomerBrandIds: Array<number> | null;
    competitorBrands: Array<CompetitorType>;
    selectedCompetitorBrandIds: Array<number> | null;
};
